import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import ACSplitTypeDetail from '../../components/ac_split_type/ACSplitTypeDetail';
import { defaultRejectHandler, toCoolingCap } from '../../utils/utility';
import {
  getACSpiltType,
  editACSpiltType,
} from '../../redux/ac_split_type/ac_split_type_actions';

class ACSplitTypeEditModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };

    this.acDetail = undefined;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.ac !== nextProps.ac && nextProps.show) {
      this.props.getAC(nextProps.ac.id);
    }
  }

  onSaveHandler() {
    const editedAC = this.acDetail.getWrappedInstance().getWrappedInstance().getACData();
    this.props.editAC({
      ...editedAC,
      id: this.props.ac.id,
    });
  }

  render() {
    const {
      isEditing,
      errorMessage,
      acDetail,
      editAC,
      getAC,
      t,
      ...newProps
    } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('edit a/c split type')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ACSplitTypeDetail
            ac={acDetail}
            ref={ref => (this.acDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isEditing && !this.props.isEdited && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="air-conditioning-split-type-submit-edit"
            disabled={!isSubmittable || isEditing}
            onClick={() => this.onSaveHandler()}
          >
            {isEditing ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, props) => ({
  errorMessage: state.ac.splitType.errorMessage,
  isEditing: state.ac.splitType.isEditing,
  acDetail: props.ac && state.ac.splitType.objects[props.ac.id],
});

const mapDispatchToProps = dispatch => ({
  editAC: ac =>
    defaultRejectHandler(
      dispatch(
        editACSpiltType(
          ac.id,
          ac.name,
          ac.type,
          ac.brand_id,
          ac.SEER,
          toCoolingCap(ac.cooling_capacity, ac.unit),
          ac.unit,
          ac.power_required,
          ac.description,
          ac.image,
          ac.cfp_value,
          ac.cfp_unit,
        ),
      ),
    ),
  getAC: id => defaultRejectHandler(dispatch(getACSpiltType(id))),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ACSplitTypeEditModal),
);



// WEBPACK FOOTER //
// ./src/modal/ac_split_type/ACSplitTypeEditModal.js